import React, {useEffect} from 'react'
import apiClient from '../http-common';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';
import { setCoins, setAddresses, setRate, setForex, setStock } from './coinSlice';

export const FetchCoinRates = () => {
  const dispatch = useDispatch();

    const { isLoading: isloadingCoins, refetch: fetchCoins } = useQuery(
        "get-coin-rate",
        async () => {
          return await apiClient.get("/api/get-coin-rate");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
              dispatch(setCoins(res.data.coins))
              dispatch(setAddresses(res.data.addresses))
              dispatch(setRate(res.data.coin_rate))             
              dispatch(setForex(res.data.forex))             
              dispatch(setStock(res.data.stock))
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );

      useEffect(() => {
        fetchCoins();
      }, []);
 
}

export default FetchCoinRates
